export const GENERAL_VALIDATION_CONSTANTS = {
  ENTER_VALID_EMAIL: "Enter a valid email",
  EMAIL_REQUIRED: "Email filed is required",
  PHONE_NUMBER_REQUIRED: "Phone number is required",
  INVALID_PHONE_NUMBER: "Invalid phone number",
  MOBILE_NUMBER_MIN_LENGTH_9: "Mobile number must be at least 9 characters",
  MOBILE_NUMBER_MAX_LENGTH_10: "Mobile number must have maximum 10 characters",
  PASSWORD_REQUIRED: "Password is required!",
  AT_LEAST_ONE_LOWERCASE: "At least one lowercase letter",
  AT_LEAST_ONE_UPPERCASE: "At least one uppercase letter",
  AT_LEAST_ONE_NUMBER: "At least one number",
  AT_LEAST_ONE_SPECIAL_CHARACTER: "At least one special character",
  MINIMUM_8_CHARACTERS: "Minimum 8 characters",
  INVALID_PASSWORD: "Invalid password",
  PASSWORD_MISMATCH: "Passwords must match",
  COUNTRY_REQUIRED: "Country is required!",
  CONFIRM_PASSWORD_REQUIRED: "Confirm password is required",
  FIRST_NAME_REQUIRED: "First name is required",
  MIDDLE_NAME_REQUIRED: "Middle name is required",
  SURNAME_REQUIRED: "Surname is required",
  ACCOUNT_TYPE_REQUIRED: "Account type is required",
  INVALID_ACCOUNT_TYPE: "Invalid account type",
  VALIDATION_ERROR: "Validation error"
} as const;
